import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {Option, OptionGroup} from '../../../shared/models/option';


@Component({
    selector: 'motn-multichoice-horizontal',
    templateUrl: './multichoice-horizontal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./multichoice-horizontal.component.scss'],
})
export class MultichoiceHorizontalComponent implements OnInit {
  @Input() options: OptionGroup;
  @Output() selectedItem$: EventEmitter<Option> = new EventEmitter<Option>();

  constructor() {
  }

  ngOnInit(): void {
  }

  onClick(option: Option) {
    this.options.changeSelected(option.id);
    this.selectedItem$.next(option);
  }
}
